import Image from "../Elements/Image";

const Checkbox = ({
  label,
  inputName,
  classes,
  current,
  setCurrent,
  inputRequired,
  isImage,
  image
}) => {
  return (
    <>
      <div className={"checkbox" + (" " + classes) + (isImage?" checkbox-image":"")}>
        <input
          type="checkbox"
          name={inputName}
          className="checkbox-input"
          checked={current ? true : false}
          onChange={(e) => setCurrent(e.target.checked)}
        />
        <div className="checkbox-icon"></div>
        {isImage &&
        <div className="checkbox-image">
          <Image src={image} alt={label} width={'100%'} height={'100%'} effect={'blur'}/>
        </div>
        }
        {label && (
          <div
            className={"checkbox-label" + (inputRequired ? " required" : "")}
          >
            {label}
          </div>
        )}
      </div>
    </>
  );
};

export default Checkbox;
